import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { commonAtcReducer } from './atc/atc.reducer';
import { commonPersonReducer } from './person/person.reducer';
import { commonDoctorReducer } from './doctor/doctor.reducer';
import { commonPatientReducer } from './patient/patient.reducer';
import { commonCieReducer } from './cie/cie.reducer';
import { commonTurnReducer } from './turn/turn.reducer';
import { commonQuestionReducer } from './question/question.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('common', {
      atc: commonAtcReducer,
      person: commonPersonReducer,
      doctor: commonDoctorReducer,
      patient: commonPatientReducer,
      cie: commonCieReducer,
      turn: commonTurnReducer,
      question: commonQuestionReducer,
    }),
  ],
})
export class CommonStoreModule {}
